import { withErrorBoundary } from 'shared'
import { InfoNavbar } from 'layout'

const Information = () => {
  return <div className="information-page mt-md-3"> <InfoNavbar /> </div>
}

export default withErrorBoundary(Information)
